import moment from 'moment'

/**
 * ISO week keys, the unit the city plan pages work in.
 *
 * A roster id in the URL and a week key from the API are the same thing:
 * "<isoYear>-<isoWeek>", week UNPADDED ("2026-5"), exactly what
 * Utils/Mission groupMissionsByWeek has always produced. Both forms are
 * accepted on input.
 */

const KEY_PATTERN = /^(\d{4})-(\d{1,2})$/

/**
 * @param {number|string} isoYear
 * @param {number|string} isoWeek
 * @returns {string}
 */
export const isoWeekKey = (isoYear, isoWeek) =>
  `${Number(isoYear)}-${Number(isoWeek)}`

/**
 * @param {string} key "2026-38" or "2026-05"
 * @returns {?{isoYear: number, isoWeek: number}} null when it is not a key
 */
export const parseIsoWeekKey = key => {
  const match = KEY_PATTERN.exec(String(key || '').trim())
  if (!match) return null
  const isoYear = Number(match[1])
  const isoWeek = Number(match[2])
  if (isoWeek < 1 || isoWeek > 53) return null
  return { isoYear, isoWeek }
}

/**
 * The current ISO week and the `ahead` weeks after it - the weeks the roster
 * list always shows so a manager can plan into them.
 * @param {Date} [now]
 * @param {number} [ahead]
 * @returns {Array<string>}
 */
export const forecastWeekKeys = (now = new Date(), ahead = 2) => {
  const keys = []
  const cursor = moment(now)
  for (let i = 0; i <= ahead; i += 1) {
    keys.push(isoWeekKey(cursor.isoWeekYear(), cursor.isoWeek()))
    cursor.add(1, 'week')
  }
  return keys
}
